import React from "react"
import PropTypes from "prop-types"
import Tag from "../tag"
import * as Icon from "react-feather"
import SbImageService, { isSvg } from "../../helpers/SbImageService"
import avatar from "../../assets/images/avatar.svg"

const UserCard = ({ avatarUrl, name, location, programs }) => (
  <div className="user-card card">
    <div className="user-card__top">
      <div className="user-card__top-left">
        <div
          className={`lazyload user-card__image${
            avatarUrl ? " user-card__image--with-photo" : ""
          }`}
          data-bg={SbImageService(avatarUrl || avatar)}
          style={
            isSvg(avatarUrl || avatar)
              ? { backgroundImage: `url("${avatarUrl || avatar}")` }
              : null
          }
        ></div>
        <div className="user-card__info">
          <p className="user-card__name">{name}</p>
          <p className="user-card__location">{location}</p>
        </div>
      </div>
      <div className="user-card__cta">
        <Icon.ArrowRight className="icon icon--sm" />
      </div>
    </div>
    <div className="user-card__bottom">
      {programs &&
        programs.map((p) => (
          <div key={p} className="user-card__bottom-slot">
            <Tag label={p} />
          </div>
        ))}
      {programs && programs.length === 0 && (
        <div className="user-card__bottom-slot">
          <Tag label="none" />
        </div>
      )}
    </div>
  </div>
)

UserCard.defaultProps = {
  name: "",
  location: "",
  avatar: "",
  programs: [],
}

UserCard.propTypes = {
  name: PropTypes.string,
  location: PropTypes.string,
  avatarUrl: PropTypes.string,
  programs: PropTypes.arrayOf(PropTypes.string),
}

export default UserCard
